/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from './api.js';
window.birdata = birdata; // Useful for debugging

// --- Javascript error tracking ---
import * as Sentry from "@sentry/browser";
Sentry.init({
	dsn: "https://81e2489392e8479b9ae7c9b263bf5658@o80104.ingest.sentry.io/174239",
	release: "__GIT_CURRENT_SHORT_HASH__", // see dep.sh
	allowUrls: [
		/https?:\/\/birdata.birdlife.org.au/
	],
	ignoreErrors: [
		/XHR Error 401/,
		/XHR Error 0:/,
		"Non-Error promise rejection captured with value: Object Not Found Matching Id", // https://stackoverflow.com/questions/75536442/troubleshooting-non-error-promise-rejection-captured-with-value-object-not-fou
	],
	integrations: function(integrations) {
		if(window.location.hostname == 'localhost') {
			integrations = integrations.filter(integration => integration.name !== "Breadcrumbs")
		}
		return integrations;
	}
});

birdata.me(true).noLoginRedirect()
	.catch(function() {})
	.then(function(me) {
		if(!me) return;

		Sentry.setUser({
			id: me.id,
			email: me.email
		});
	});

// Make sure unhandled promise rejections get reported
// TODO: Check if this is still necessary with new Sentry JS lib
// window.addEventListener("unhandledrejection", function(evt) {
// 	var err = evt.detail.reason;
// 	if(err.doNotReport) return;
// 	Raven.captureException(err);
// });
// ---------------------------------

// Minimal toSorted Polyfill
if (!Array.prototype.toSorted) {
	Array.prototype.toSorted  = function(compareFn) {
		const arr = this;
		const res = [...arr];
		res.sort(compareFn);
		return res;
	}
}

import ko from "knockout";

// For better performance - see http://knockoutjs.com/documentation/deferred-updates.html
ko.options.deferUpdates = true;

import './ui/survey-edit.js';
import './ui/survey-list.js';
import './ui/my-data.js';
import './ui/shared-sites.js';
import './ui/shared-site-details.js';
import './ui/programs-regions.js';
import './ui/explore.js';
import './ui/event.js';
import './ui/booking-map.js';
import './ui/book-site.js';
import './ui/species-map.js';
import './ui/species-graph.js';
import './ui/home-stats.js';
import './ui/individual-stats.js';
import './ui/feedback.js';
import './ui/admin/admin.js';
import './ui/survey.js';
import './ui/quiz.js';
import './ui/delete-account.js';
import './ui/vetting.js';

import './ui/shared/loading-indicator.js';
import './ui/shared/field.js';
import './ui/shared/validation-label.js';

import './util/resizable-columns.js';

ko.applyBindings();

// Auto-position help popups
document.body.addEventListener("mouseover", function(event) {
	if(event.target.matches(".auto-position-help label .help *")) {
		let helpDom = event.target.closest(".help");
		let rect = helpDom.getBoundingClientRect();
		let left = rect.left, right = window.innerWidth - rect.right;
		let top = rect.top, bottom = window.innerHeight - rect.bottom;

		let textDom = helpDom.querySelector(".text");
		textDom.classList.toggle("right", left > right);
		textDom.classList.toggle("top", top > bottom);
	}
});
